/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Kind_Home_TabInputs */

const vi_shop_home_kind_home_tab = /** @type {(inputs: Shop_Home_Kind_Home_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tab dòng chè`)
};

/**

* @param {Shop_Home_Kind_Home_TabInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_kind_home_tab = /** @type {((inputs?: Shop_Home_Kind_Home_TabInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Kind_Home_TabInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_kind_home_tab(inputs)
});